import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import styles from './ZoomIcon.scss'

const ZoomIcon = props => (
	<svg styleName="ZoomIcon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" onClick={props.onClick}>
		<g fill="#FFF" fillRule="evenodd" transform="rotate(-90 8 8)">
			<circle styleName='color-change' fill='none' cx="8" cy="8" r="8"></circle>
			<path fillRule="nonzero" d="M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z" />
			{props.in && <path d="M8.7,8.7 L11.4982687,8.7 C11.8809673,8.7 12.2,8.38659932 12.2,8 C12.2,7.61070538 11.8858242,7.3 11.4982687,7.3 L8.7,7.3 L8.7,4.50173131 C8.7,4.11903267 8.38659932,3.8 8,3.8 C7.61070538,3.8 7.3,4.11417581 7.3,4.50173131 L7.3,7.3 L4.50173131,7.3 C4.11903267,7.3 3.8,7.61340068 3.8,8 C3.8,8.38929462 4.11417581,8.7 4.50173131,8.7 L7.3,8.7 L7.3,11.4982687 C7.3,11.8809673 7.61340068,12.2 8,12.2 C8.38929462,12.2 8.7,11.8858242 8.7,11.4982687 L8.7,8.7 Z" />}
			{props.out && <path d="M11.4982687,7.3 C11.8858242,7.3 12.2,7.61070538 12.2,8 L12.2,8 C12.2,8.38659932 11.8809673,8.7 11.4982687,8.7 L4.50173131,8.7 C4.11417581,8.7 3.8,8.38929462 3.8,8 L3.8,8 C3.8,7.61340068 4.11903267,7.3 4.50173131,7.3 L11.4982687,7.3 L11.4982687,7.3 Z" transform="rotate(90 8 8)" />}
		</g>
	</svg>
)

ZoomIcon.propTypes = {
	onClick: PropTypes.func,
	in: PropTypes.bool,
	out: PropTypes.bool,
}

ZoomIcon.defaultProps = {
	onClick: () => { },
	in: false,
	out: false,
}

export default CSSModules(ZoomIcon, styles, { allowMultiple: true })
